import { checkboxAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys)


  const sizes = {
    xl: definePartsStyle({
      control: defineStyle({
        boxSize: 20
      }),
      label: defineStyle({
        fontSize: "2xl",
        marginLeft: 6
      })
    }),
    xxl: definePartsStyle({
      control: defineStyle({
        boxSize: 40
      }),
      label: defineStyle({
        fontSize: "4xl",
        marginLeft: 0,
      })
    }),
  }



export const checkboxTheme = defineMultiStyleConfig({ sizes })